import React from "react";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { loginWithLark } = useAuth();

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">🗂️</div>
        <h1>Task</h1>
        <p>Sign in with your Lark account to access your dashboard</p>

        <button
          className="btn btn-primary"
          style={{
            width: "100%", justifyContent: "center",
            padding: "13px", fontSize: 15, marginTop: 8,
            gap: 10, borderRadius: 10,
          }}
          onClick={loginWithLark}
        >
          <span style={{ fontSize: 20 }}>🔑</span>
          Continue with Lark
        </button>

        <div style={{
          marginTop: 24, paddingTop: 20,
          borderTop: "1px solid var(--gray-100)",
          textAlign: "center",
        }}>
          <span style={{ fontSize: 11, color: "var(--gray-400)" }}>
            Powered by Lark Base • Task
          </span>
        </div>
      </div>
    </div>
  );
}
